import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { ImageExtension, ImageType, FileWeirExtension, FileExtension, FileApplicationType } from '../_appCommon/base/AppInterfaceAndBaseClasses';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';
import { UrlQueryDef } from '../_appCommon/base/UrlQueryDef';
import { Section } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';


@Injectable()
export class MediaDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient)
  {
    super(http, "media");
  }

  protected loadEntityConfig(): void
  {
    // Get the Entity Config
    this.entityConfig = new EntityConfig();

    this.entityConfig.canEdit = true;
    this.entityConfig.canRead = true;
    this.entityConfig.entityName = "Media";
    this.entityConfig.entityDisplayName = "Media";
    this.entityConfig.apiUrl = "api/Media";
  }

  public saveImage(file: File): Observable<object>
  {
    let name = this.setImageName(file.type, file.name);
    // create multipart form for file
    let formData: FormData = new FormData();

    formData.append('file', file, name);


    const headers = new HttpHeaders().append('Content-Disposition', 'mulipart/form-data').append('SECTION',Section.Ecommerce.toString());

    let observable = this.http.post(this.entityConfig.apiUrl + "/save", formData, { headers: headers }).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  public getBlobFileById(blobId: any): Observable<object>
  {
    let queryDef = new UrlQueryDef();
    let observable: Observable<any> = this.http.get(this.entityConfig.apiUrl + "/" + blobId, queryDef.getRequestConfig()).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public replaceImage(id: number, file: File)
  {
    let name = this.setImageName(file.type, file.name);

    // create multipart form for file
    let formData: FormData = new FormData();

    formData.append('file', file, name);

    const headers = new HttpHeaders().append('Content-Disposition', 'mulipart/form-data').append('SECTION',Section.Ecommerce.toString());

    let observable = this.http.post(this.entityConfig.apiUrl + "/replace/" + id, formData, { headers: headers }).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }

  public deleteImage(id: number)
  {
    let queryDef = new UrlQueryDef();

    let observable = this.http.delete(this.createUrl(this.delete_WebApiMethod, id), queryDef.getRequestConfig(true)).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }
  private nameGenerator(fileName: string): string
  {
    //Create a unique name!
    let date = new Date();
    //FileNameDayMontYearHourMinuteSecondMilliseconds
    let fileNameTemp = date.toISOString();
    fileNameTemp = fileNameTemp.replaceAll("-", "");
    fileNameTemp = fileNameTemp.replaceAll("T", "");
    fileNameTemp = fileNameTemp.replaceAll(":", "");
    fileNameTemp = fileNameTemp.replaceAll(".", "");
    fileNameTemp = fileNameTemp.replaceAll("Z", "");
    //Delete file extension
    let index = fileName.lastIndexOf(".");
    let fileNameModified = fileName.slice(0, index);
    //Erase any possible "_"
    fileNameModified = fileNameModified.replaceAll("_", "");
    return fileNameTemp + "_" + fileNameModified;
  }
  private setImageName(type: any, fileOriginalName: any): string
  {

    let name = this.nameGenerator(fileOriginalName);

    switch (type)
    {
      case ImageType.JPG:
        name += ImageExtension.JPG;
        break;
      case ImageType.JPEG:
        name += ImageExtension.JPEG;
        break;
      case ImageType.PNG:
        name += ImageExtension.PNG;
        break;
      case ImageType.GIF:
        name += ImageExtension.GIF;
        break;
      case ImageType.TIF:
        name += ImageExtension.TIF;
        break;
      case ImageType.BMP:
        name += ImageExtension.BMP;
        break;
      case FileApplicationType.PDF:
        name += FileExtension.PDF;
        break;
      case FileApplicationType.STL:
        name += FileWeirExtension;
        break;
      case FileApplicationType.TXT:
        name += FileExtension.TXT;
        break;
      case FileApplicationType.ZIP:
        name += FileExtension.ZIP;
        break;
      case FileApplicationType.ZIP7:
        name += FileExtension.ZIP7;
        break;
      case FileApplicationType.RAR:
        name += FileExtension.RAR;
        break;
      case FileApplicationType.WORD:
        name += FileExtension.WORD;
        break;
      case FileApplicationType.POWERPOINT:
        name += FileExtension.POWERPOINT;
        break;
      case FileApplicationType.EXCEL:
        name += FileExtension.EXCEL;
        break;
      case '':
        name += FileWeirExtension.STL;
        break;
    }
    return name;
  }
}
